import { createBrowserHistory } from 'history'
import { basename } from 'constants/index'

export default createBrowserHistory({ basename })
